import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/map/$mapSlug/place-pois")({
  validateSearch: (search: Record<string, unknown>) => ({
    importBatchId:
      typeof search.importBatchId === "string" ? search.importBatchId : undefined,
  }),
  // Component in lazy file for code splitting (includes MapLibre)
});
